import * as PropTypes from 'prop-types';
import React, { createContext, useState } from 'react';

export const RedocContext = createContext();

export const RedocProvider = (props) => {
    const isInternal =
        window.location.hostname.includes('internal') ||
        window.location.hostname.includes('localhost');
    const urlParams = new URLSearchParams(window.location.search);
    const defaultApi = isInternal ? urlParams.get('api') ?? 'v2' : 'public';
    const defaultRevision = urlParams.get('revision') ?? 'latest';

    const specBaseUrl = '/specifications';
    const [ specState, setSpecState ] = useState({
        specUrl: `${specBaseUrl}/${defaultApi}/${defaultRevision}.json`,
        revision: defaultRevision,
        api: defaultApi,
        isInternal: isInternal
    });

    const changeSpecState = (state) => {
        const newState = {
            ...specState,
            ...state
        };

        setSpecState({
            ...newState,
            specUrl: `${specBaseUrl}/${newState.api}/${newState.revision}.json`
        });
    };

    return (
        <RedocContext.Provider value={{ specState, changeSpecState }}>
            {props.children}
        </RedocContext.Provider>
    );
};

RedocProvider.propTypes = {
    children: PropTypes.arrayOf(PropTypes.object)
};
